class ChooseAccountUsersController {
  static controller($scope, $state) {
    'ngInject';


  };
}

export default ChooseAccountUsersController.controller;



// WEBPACK FOOTER //
// ./src/users/forgot-password/choose-account.users.controller.js